(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('CampaignManagementFormController', campaignManagementFormController)

  campaignManagementFormController.inject = ['$scope', 'ngTableParams', '$http', '$stateParams', '$state', 'LangService', 'CampaignManagementFormService', 'NotificationService', 'Upload', '$timeout']

  function campaignManagementFormController($scope, ngTableParams, $http,  $stateParams, $state, LangService, CampaignManagementFormService, NotificationService, Upload, $timeout) {
    var vm = this;

    vm.dynamicFields = {
      subChannel: false,
      fieldWithTelephone: false,
      fieldWithCPF: false,
      fieldWithDossie: false,
      fieldWithEmail: false,
      subjectOfEmail: false,
      replyChannelEmailId: false
    };

    vm.channels = [];

    vm.subChannels = [];

    vm.sectors = [];

    vm.hsms = [];

    vm.sectors = [];

    vm.campaign = initCampaignObject();

    vm.channelSelected = null

    vm.variablesOnMessage = [];

    vm.isEditing = isEditing();

    LangService
      .getPageLabels({ 'page': 'menu.campaign' })
      .$promise
      .then(function (data) {
        vm.labelsPage = data.lang;
      });

    LangService
      .getPageLabels({ 'page': 'campaignChannelTypeConstants' })
      .$promise
      .then(function (data) {
        vm.labelsCampaignChannelTypeConstants = data.lang;
      });

    CampaignManagementFormService.getSectors().$promise
      .then(function (response) {
        vm.sectors = response.data
      });

    loadConstants();

    getCampaign();

    window.dropFile = function(e) {
      e.preventDefault();
      var fileObject = e.dataTransfer.files[0];
      vm.campaign.fileName = fileObject.name;
      vm.campaign.message = null;

      getFieldsFromFile(fileObject);
    }

    vm.selectFile = function() {
      document.getElementById('selectedFile').click();
      document.getElementById('selectedFile').onchange = function () {
        var fileObject = document.getElementById('selectedFile').files[0];
        vm.campaign.fileName = fileObject.name;
        vm.campaign.message = null;

        getFieldsFromFile(fileObject);
      };
    }

    vm.loadDataByChannelType = async function (channelType) {
      displayFieldsByChannelType(channelType);
      vm.campaign.channelSetting.sendingChannelId = null;
      vm.campaign.messageParameters = [];
      vm.variablesOnMessage = [];

      await CampaignManagementFormService.getChannels({'channelType': channelType}).$promise
        .then(function (response) {
          vm.channels = response.data
        });

      if (channelType == CampaignChannelTypeConstants.WHATSAPP) {
        await CampaignManagementFormService.getListHsm().$promise
          .then(function (response) {
            vm.hsms = response.data
          });
      }

      clearCampaignForm();
    }

    vm.getSubChannels = async function(channelId) {
      vm.subChannels = [];
      if (channelId == null || vm.campaign.channelType != CampaignChannelTypeConstants.WHATSAPP) {
        return;
      }

      var channelUuid = getChannelUuid(parseInt(channelId));
      if (!channelUuid) {
        return;
      }

      await CampaignManagementFormService.getSubChannels({'channelUuid': channelUuid}).$promise
        .then(function (response) {
          if (response.data && response.data.subchannels) {
            vm.subChannels = response.data.subchannels;
          }
        });
    }

    vm.addVariableOnTemplate = function(fileColumn) {
      var messageTextArea = document.getElementById('messageTextArea');

      var variableOnTemplate = '{$' + fileColumn + '$}';
      vm.configMessageParams(fileColumn);

      if (!messageTextArea.selectionStart) {
        vm.campaign.message = variableOnTemplate;
        return;
      }

      var startPos = messageTextArea.selectionStart;
      var endPos = messageTextArea.selectionEnd;
      var startString = messageTextArea.value.substring(0, startPos);
      var endString = messageTextArea.value.substring(endPos, messageTextArea.value.length);

      vm.campaign.message = `${startString}${variableOnTemplate}${endString}`;

      if (messageTextArea.setSelectionRange) {
        var cursorPos = startPos + (variableOnTemplate.length);
        messageTextArea.focus();
        messageTextArea.setSelectionRange(cursorPos, cursorPos);
      }

      return;
    }

    vm.isChannelTypeWhatsappSelected = function() {
      if (vm.campaign.channelType == null) return false
      return vm.campaign.channelType == vm.campaignChannelTypeConstants.WHATSAPP
    }

    vm.shouldDisableMessageField = function() {
      if (vm.campaign.channelType == null) return true
      return vm.campaign.channelType == vm.campaignChannelTypeConstants.WHATSAPP
    }

    vm.shouldDisableChannelSelection = function() {
      return vm.campaign.fileColumns.length <= 0
    }

    vm.shouldShowButtonsToBuildMsg = function() {
      if (vm.campaign.channelType == null) return false
      return vm.campaign.channelType != vm.campaignChannelTypeConstants.WHATSAPP;
    }

    vm.selectHsm = function(hsmId) {
      vm.campaign.messageParameters = [];
      if (!hsmId) {
        vm.campaign.message = null;
        vm.totalVariablesOnMessage = 0;
        return null;
      }

      var hsm = vm.hsms.find(function (item) {
        if (item.id == hsmId) {
          return item;
        }
      });

      vm.campaign.message = hsm.template;
      vm.campaign.channelSetting.hsmId = hsmId;
      vm.variablesOnMessage = getVariablesOnMessage(vm.campaign.message);
    }

    vm.save = function() {
      if (isEditing()) {
        CampaignManagementFormService.updateCampaign({
          id: $stateParams.id
        }, vm.campaign).$promise.then(function () {
          NotificationService.successHandler(null, "Campanha atualizada com sucesso!");
          $state.go('main.campaign-management');
        })
        .catch(function (response) {
          NotificationService.errorHandler(null, response.data.error);
        });

        return;
      }

      CampaignManagementFormService.saveCampaign(vm.campaign).$promise
        .then(function () {
          NotificationService.successHandler(null, "Campanha salva com sucesso!");
          $state.go('main.campaign-management');
        })
        .catch(function (response) {
          NotificationService.errorHandler(null, response.data.error);
      });
    }

    vm.configMessageParams = function (fileColumn) {
      vm.campaign.messageParameters.push(fileColumn);
    }

    function getVariablesOnMessage(message) {
      var variablesOnMessage = message.match(/{{[A-Za-z0-9_-]{1,2}}}/g);

      if (variablesOnMessage == null) {
        return [];
      }

      return variablesOnMessage;
    }

    function clearCampaignForm() {
      vm.campaign.message = null;
      vm.campaign.channelSetting.hsmId = null;
    }

    function displayFieldsByChannelType(channelType) {
      if (channelType == CampaignChannelTypeConstants.WHATSAPP) {
        vm.dynamicFields = {
          subChannel: true,
          fieldWithTelephone: true,
          fieldWithCPF: true,
          fieldWithDossie: true,
          fieldWithEmail: false,
          subjectOfEmail: false,
          replyChannelEmailId: false
        }
      } else if (channelType == CampaignChannelTypeConstants.EMAIL) {
        vm.dynamicFields = {
          subChannel: false,
          fieldWithTelephone: false,
          fieldWithCPF: true,
          fieldWithDossie: true,
          fieldWithEmail: true,
          subjectOfEmail: true,
          replyChannelEmailId: true
        }
      } else if (channelType == CampaignChannelTypeConstants.SMS) {
        vm.dynamicFields = {
          subChannel: false,
          fieldWithTelephone: true,
          fieldWithCPF: true,
          fieldWithDossie: true,
          fieldWithEmail: false,
          subjectOfEmail: false,
          replyChannelEmailId: false
        }
      } else {
        vm.campaign.fileColumns = [];
        vm.dynamicFields = {
          subChannel: false,
          fieldWithTelephone: false,
          fieldWithCPF: false,
          fieldWithDossie: false,
          fieldWithEmail: false,
          subjectOfEmail: false,
          replyChannelEmailId: false
        };
      }
    }

    function loadConstants() {
      vm.campaignChannelTypeConstants = CampaignChannelTypeConstants;
    }

    function getFieldsFromFile(fileObject) {
      Upload.upload({
        url: frontUrl + '/get-fields-from-file',
        file: fileObject
      }).then(function (response) {
        vm.campaign.fileColumns = response.data;
        NotificationService.successHandler(null,  vm.labelsPage.getFileInformationSuccessRequest);
      }, function (response) {
        NotificationService.errorHandler(null, response.data.error);
      });
    }

    function getChannelUuid(channelId) {
      var channel = vm.channels.find(function (item) {
        if (item.id == channelId) {
          return item
        }
      });

      if (channel && channel.uuid != undefined) {
        return channel.uuid
      }

      return null
    }

    function getDefaultDueDate() {
      var startDate = new Date();
      const NUMBER_OF_DAYS_TO_EXPIRATION = 30;

      return new Date(startDate.setDate(startDate.getDate()+NUMBER_OF_DAYS_TO_EXPIRATION));
    }

    function getCampaign() {
      if (!isEditing()) {
        return;
      }

      CampaignManagementFormService.getCampaign({'id': $stateParams.id,}).$promise
      .then(function (response) {
        var campaign = response.data;
        fillCampaignObject(campaign);
      })
      .catch(function (response) {
        NotificationService.errorHandler(null, response.data.error);
      });
    }

    function isEditing() {
      if ($stateParams.id) {
        return true;
      }

      return false;
    }

    function initCampaignObject() {
      return {
        name: null,
        dueDate: getDefaultDueDate(),
        active: true,
        messageParameters: [],
        channelType: null,
        message: null,
        fileName: null,
        fileColumns: [],
        channelSetting: {
          sendingChannelId: null,
          sectorId: null,
          replyChannelEmailId: null,
          subChannelId: null,
          hsmId: null,
          fieldWithTelephone: null,
          fieldWithCPF: null,
          fieldWithDossie: null,
          fieldWithEmail: null,
          subjectOfEmail: null,
          useChatbotForAttendance: false,
          ret: false,
          invoices: false
        }
      };
    }

    async function fillCampaignObject(campaign) {
      vm.campaign.channelType = CampaignChannelTypeConstants[campaign.channel_type].toString();
      await vm.loadDataByChannelType(vm.campaign.channelType);

      vm.campaign.name = campaign.name;
      vm.campaign.active = Boolean(campaign.active);
      vm.campaign.message = campaign.message;
      vm.campaign.fileName = campaign.file_name;
      vm.campaign.dueDate = new Date(campaign.due_date);
      vm.campaign.fileColumns = JSON.parse(campaign.file_columns);
      vm.campaign.messageParameters = JSON.parse(campaign.message_parameters);
      vm.variablesOnMessage = vm.campaign.messageParameters;

      if (campaign.channel_setting.reply_channel_email_id) {
        vm.campaign.channelSetting.replyChannelEmailId = campaign.channel_setting.reply_channel_email_id.toString();
      }

      if (campaign.channel_setting.field_with_telephone) {
        vm.campaign.channelSetting.fieldWithTelephone = campaign.channel_setting.field_with_telephone.toString();
      }

      if (campaign.channel_setting.field_with_cpf) {
        vm.campaign.channelSetting.fieldWithCPF = campaign.channel_setting.field_with_cpf.toString();
      }

      if (campaign.channel_setting.field_with_dossie) {
        vm.campaign.channelSetting.fieldWithDossie = campaign.channel_setting.field_with_dossie.toString();
      }

      if (campaign.channel_setting.field_with_email) {
        vm.campaign.channelSetting.fieldWithEmail = campaign.channel_setting.field_with_email.toString();
      }

      if (campaign.channel_setting.hsm_id) {
        vm.campaign.channelSetting.hsmId = campaign.channel_setting.hsm_id.toString();
      }

      if (campaign.channel_setting.channel_whatsapp_enterprise_id) {
        vm.campaign.channelSetting.sendingChannelId = campaign.channel_setting.channel_whatsapp_enterprise_id.toString();
      }

      if (campaign.channel_setting.channel_email_id) {
        vm.campaign.channelSetting.sendingChannelId = campaign.channel_setting.channel_email_id.toString();
      }

      if (campaign.channel_setting.channel_sms_id) {
        vm.campaign.channelSetting.sendingChannelId = campaign.channel_setting.channel_sms_id.toString();
      }

      await vm.getSubChannels(vm.campaign.channelSetting.sendingChannelId);
      if (vm.campaign.channelSetting.sendingChannelId && campaign.channel_setting.sub_channel_id) {
        vm.campaign.channelSetting.subChannelId = campaign.channel_setting.sub_channel_id.toString();
      }

      if (campaign.channel_setting.sector_id) {
        vm.campaign.channelSetting.sectorId = campaign.channel_setting.sector_id.toString();
      }

      vm.campaign.channelSetting.subjectOfEmail = campaign.channel_setting.subject_of_email;
      vm.campaign.channelSetting.useChatbotForAttendance = Boolean(campaign.channel_setting.use_chatbot_for_attendance);
      vm.campaign.channelSetting.ret = Boolean(campaign.channel_setting.ret);
      vm.campaign.channelSetting.invoices = Boolean(campaign.channel_setting.invoices);

      $timeout(function() {
        $scope.$apply();
      });
    }
  }
})();
